export const CONSTANTS = {
    ALL: 'ALL',
    CREATED: 'CREATED',
    FINISHED: 'FINISHED',
    DELETED: 'DELETED',
    SUCCESS: 'SUCCESS',
    REJECTED: 'REJECTED',
    CONFORME: 'CONFORME',
    NOTCONFORME: 'NOTCONFORME',
    RESERVED: 'RESERVED',
    FAVORABLE: 'FAVORABLE',
    NOTFAVORABLE: 'NOTFAVORABLE',
    AWAITING: 'AWAITING',
    CONFIRMED: 'CONFIRMED',
    DESISTED: 'DESISTED',

    CIVILITE: 'CIVILITE',
    SCOLARITE: 'SCOLARITE',
    FORMATION: 'FORMATION',
    PIECES: 'PIECES',
    RESULTAT: 'RESULTAT',
    TYPE_EI: 'TYPE_EI',
    AVIS: 'AVIS',
    PREAVIS: 'TYPE_PREAVIS',
    ETAT: 'ETAT',
    AUTRE: 'AUTRE',
    AUTRES: 'AUTRES',
    FC: 'FC',
    MASTER: 'MASTER',
    CPES: 'CPES',
    DIPLOME: 'DIPLOME',
    INTERNATIONAL: 'INTERNATIONAL' ,
    GENERAL: 'GENERAL',
    SERVICE: 'SERVICE',
    REGISTER_CONFIRMATION: 'register_confirmation',
    FAQ: 'FAQ',
    COMMENTAIRE: 'COMMENTAIRE',
    ECHELON: 'ECHELON',
    STATUT_ENSCOL: 'STATUT_ENSCOL',
    CONFIRMATION: 'CONFIRMATION',
    ESPACECANDIDAT: 'espaceCandidat',
    ESPACE_CONNEXION: 'ESPACE_CONNEXION',

    VDIP_ANNEE : 'VDIP_ANNEE',
    DISCIPLINE_ECH_INT : 'DISCIPLINE_ECH_INT',

    CANDIDATURES: 'candidatures',
    CANDIDATURE: 'candidature',
    FORMATIONS: 'formations',

    NIVEAU: 'NIVEAU',
    MENTION: 'MENTION',
    PARCOURS: 'PARCOURS',
    DISCIPLINE: 'DISCIPLINE',

    FORMULAIRE_RECOMMANDATION: 'FormulaireRecommandationENS',

    PROGRAMME_EM_LYON_ID : 9996,
    DOUBLE_CURSUS_ID : 9997,
    ECHANGE_INTERNATIONAL_ID : 9998,
    CONTACT_PEDAGO : 'CONTACT_PEDAGO',
    CONTACT_ADMIN : 'CONTACT_ADMIN',

    NONE: 'NONE',
    CASPARTICULIER: 'CASPARTICULIER',

    NON_CONCERNE: 0,
    EN_ECHANGE: 1,
    HORS_ECHANGE: 2,

    MENTION_ATTENTE_RESULTAT_CODE: 0,
    URL_EN_SAVOIR_PLUS_DIPLOME: "URL_EN_SAVOIR_PLUS_DIPLOME"

};
export const CodeTypeEtablissement = [
    'FRANCAIS', 'EFE', 'ETRANGER'
];





// WEBPACK FOOTER //
// ./src/main/webapp/app/cadens.constants.ts